// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"786d1ef6","249":"a74250c5","396":"e0240847","553":"9013ce52","655":"493e975e","981":"335d7f2c"}[chunkId] + ".chunk.css";
};